// extracted by mini-css-extract-plugin
module.exports = {"listIcons":"bz_j5","listIcons_size_lg":"bz_j6","listIcons__item":"bz_j7","listIcons__icon":"bz_j8"};